<template>

  <div>
    <el-row>
      <el-col :span="12" v-for="examInfo in examInfos" :key="examInfo.id">
        <el-card shadow="hover" style="margin-left: 10px;margin-top: 10px">
          <template #header>
            <div v-if="examInfo.passed" style="font-size: 20px;text-align:center; color: green">
              {{ examInfo.paperTypeName }}：{{ examInfo.paperName }}
            </div>
            <div v-if="!examInfo.passed" style="font-size: 20px;text-align:center; color: red">
              {{ examInfo.paperTypeName }}：{{ examInfo.paperName }}
            </div>
          </template>
          <el-row>
            <el-col :span="10">
              <img v-if="examInfo.passed" :src="require(`@/assets/picture/exam/passed.png`)"
                   alt="passedImg" style="width: 200px;height: 80px">
              <img v-if="!examInfo.passed" :src="require(`@/assets/picture/exam/lossed.png`)"
                   alt="notPassedImg" style="width: 200px;height: 80px">
              <div> {{ examInfo.createdTime }}</div>
              <div style="font-size: 16px;"> 用时:{{ examInfo.usedTime }}</div>
              <div style="font-size: 16px;"> 总分数:{{ examInfo.totalScore }}</div>
            </el-col>
            <el-col :span="14">
              <el-table :data="examInfo.examAnswerInfoDtoList" title="详细得分">
                <el-table-column prop="typeName" label="科目类型">
                </el-table-column>
                <el-table-column prop="correctCount" label="正确题数">
                </el-table-column>
                <el-table-column prop="errorCount" label="错误题数">
                </el-table-column>
                <el-table-column prop="score" label="得分">
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </el-card>

      </el-col>
    </el-row>


  </div>
</template>

<script>
import request from "../../utils/request";
import {ref} from "vue";
import {ElMessage} from "element-plus";

let userId = localStorage.getItem("loginUserId");
const examInfos = ref([]);

async function getExamInfos() {
  await request.get('/examInfo/getExamInfo/all',
      {
        params: {
          userId: userId,
        }
      })
      .then(response => {
        const result = response.data; // 将接口返回的数据赋值给result
        if (result.code !== "200" && result.msg !== "") {
          ElMessage.error(result.msg);
        } else {
          examInfos.value = result.data;
        }
      })
      .catch(error => {
        console.error("sendPhoneConfirmCode error:" + error);
        // ElMessage.info("系统异常，请联系管理员");
      })
}

export default {
  name: "examHistory",
  data() {
    return {
      examInfos: examInfos,
    }
  },
  created() {
    getExamInfos.call(this)
  },
}
</script>

<style scoped>

</style>
